<template>
  <div class="home">
    <loading w="100" h="100" v-if="isLoading"></loading>
    <div v-else>
      <app-title :class="[titleColor==0 ? 'request-title':'market-title']" title="New Arrivals"></app-title>
        <div class="main-wrapper">
          <div class="slide-menu-bar">
          <p :class="[active == 1 ? 'active' : '']" @click="swipeRight">{{lang[1]}}</p>
          <p :class="[active == 2 ? 'active' : '']" @click="swipeLeft">{{lang[2]}}</p>
        </div>
        <div v-if="canNotPayment" class="sry-msg">
          {{lang[4]}}
        </div>
        <div v-else-if="!isVerificated" class="sry-msg">
          {{lang[5]}}
        </div>
        <div class="search-wrapper">
          <div class="search-form">
            <div class="tag-wrapper" v-if="tagName.length > 1">
              <div class="tag">{{tagName}} <span class="batu" @click="deleteTag()">×</span></div>
            </div>
            <n-input v-else
              v-model="searchText"
              :placeholder="lang[3]"
              type="text"
              class="search-text"
            ></n-input>
          </div>
        </div>

        <div class="main-content">
          <market api="request"
            class="requests-area" v-on:swiperight="swipeLeft" :style="`display: ${left?'none':'flex'}`"
          >
          </market>
          <market api='item'
            class="items-area" v-on:swiperight="swipeRight" :style="`display: ${left?'flex':'none'}`"
          >
          </market>
        </div>
        <div v-if="titleColor==0" class="nazuna-btn" @click="createRequest">
          <img v-if="$store.state.account.lang === 'ja'" src="../../assets/img/req-btn-ja.png">
          <img v-else src="../../assets/img/req-btn-en.png">
        </div>
        <div v-if="titleColor==1 && isVerificated" class="nazuna-btn" @click="crateItem">
          <img v-if="$store.state.account.lang === 'ja'" src="../../assets/img/item-btn-ja.png">
          <img v-else src="../../assets/img/item-btn-en.png">
        </div>
      </div>
      <app-menu active="home"></app-menu>
    </div>
  </div>
</template>

<script>
import AppMenu from '../../components/Menu.vue'
import AppTitle from '../../components/Title.vue'
import Loading from '../../components/Loading.vue'
import Market from '../../components/Market.vue'
import axios from 'axios'
import stripeCountryMaster from '../../masters/stripeCountryMaster'
import HomeLangMaster from '../../masters/langMaster/HomeLangMaster'
import NInput from '../../components/Input.vue'
export default {
  name: 'Home',
  components: {
    AppMenu,
    AppTitle,
    Loading,
    Market,
    NInput
  },
  data() {
    return {
      lang: HomeLangMaster[this.$store.state.account.lang],
      active: 1,
      left: 0,
      searchText: "",
      titleColor: 0,
      canNotPayment: false,
      isLoading: true,
      isVerificated: false,
      tagName: "",
    };
  },
  watch: {
   searchText() {
     this.$router.replace({ query: { keyword: this.searchText } })
   },
 },
  mounted() {
    //無限ローディングになる可能性があるのでログアウトさせる
    if(!this.$store.state.appState || !this.$store.state.account.lang){
      this.$store.dispatch('auth/logout');
    }
    //リクエストかアイテムかさっきまで開いてた方を表示
    this.active = this.$store.state.appState.home_active
    this.left = this.$store.state.appState.home_left
    this.titleColor = this.$store.state.appState.home_titleColor
    this.getStripeStatus()
    if(stripeCountryMaster[this.$store.state.account.country] === undefined) {
      //Stripe未対応国
      this.canNotPayment = true
      this.isLoading = false
    } else {
      if(this.$store.state.account.stripe_id === null) {
        //Stripe対応国かつstripe_idをまだ持っていない
        this.createStripeAccount()
      }
    }
  },
  methods: {
    swipeRight() {
      this.active = 1
      this.left = 0
      this.titleColor = 0
      //リクエストを開いてるのを保持
      this.$store.dispatch('appState/set', {
        home_active: this.active,
        home_left: this.left,
        home_titleColor: this.titleColor
      })
    },
    swipeLeft() {
      this.active = 2
      this.left = 1
      this.titleColor = 1
      //アイテムを開いてるのを保持
      this.$store.dispatch('appState/set', {
        home_active: this.active,
        home_left: this.left,
        home_titleColor: this.titleColor
      })
    },
    moveDetail(id) {
      this.$router.push(`/request/${id}`)
    },
    createRequest() {
      this.$router.push('/request/new')
    },
    crateItem() {
      this.$router.push('/item/new')
    },
    createStripeAccount() {
      axios.post('private/stripe/account', {
        country: stripeCountryMaster[this.$store.state.account.country],
        type: 'custom',
        business_type: 'individual'
      }).then(data => {
        axios.put(`private/user/stripe/${this.$store.state.account.id}`, {
          stripe_id: data.data.data.id
        }).then(updatedUserData => {
          localStorage.setItem('nerzex.user', JSON.stringify(updatedUserData.data.updatedModel))
          this.$store.dispatch('account/find', JSON.parse(localStorage.getItem('nerzex.user')))
          this.isLoading = false
        }).catch(err => {
          // console.log(err)
          this.isLoading = false
        })
      }).catch(err => {
        // console.log(err)
        this.isLoading = false
      })
    },
    getStripeStatus() {
      if(!this.$store.state.account.stripe_id) {
        return false
        this.isLoading = false
      }
      axios.get(`private/stripe/account/${this.$store.state.account.stripe_id}`)
      .then(data => {
        if(data.data.data.payouts_enabled) {
          this.isVerificated = true
        }
        this.isLoading = false
      }).catch(err => {
        console.log(err)
        this.isLoading = false
      })
    },
    deleteTag() {
      this.$router.push('/home')
      this.tagName = ""
    },
  }
};
</script>

<style scoped>
.active:after {
  content: '';
  width: 50%;
  height: 3px;
  background: #F35639;
  display: block;
  position: absolute;
  bottom: 0;
}

.request-title{
  background: #f39939
}

.market-title{
  background: #58acfa
}

.home {
  width: 100vw;
  /* overflow-x: hidden; */
}

.kouzi {
  padding: 10px;
}

.kouzi-img-wrapper {
  width: 80vw;
  height: 50vh;
  text-align: center;
  margin: 0 auto;
}

.kouzi-img {
  width: 100%;
}

.nazuna-btn {
  position: fixed;
  bottom: 12%;
  right: 1%;
  width: 130px;
  box-shadow: 1, 1, 1;
  filter: drop-shadow(8px 10px 6px rgba(0,0,0,0.6));
  transform: translate(0, 0);
  -webkit-animation: fuwafuwa 3s ease infinite;
  animation: fuwafuwa 3s ease infinite;
}

.nazuna-btn img {
  width: 100%;
}

.search-wrapper {
  width: 100%;
  margin: 20px auto;
}

.search-text {
  width: 100%;
  padding: 5px;
}

@keyframes fuwafuwa {
  0% { transform:translateY(0) }
  5% { transform:translateY(0) }
  10% { transform:translateY(0) }
  20% { transform:translateY(-15px) }
  25% { transform:translateY(0) }
  30% { transform:translateY(-15px) }
  50% { transform:translateY(0) }
  100% { transform:translateY(0) }
}

.requests-area, .items-area {
  position: static;
  margin-bottom: 70%;
}

.tag-wrapper {
  width: 95%;
  padding: 5px;
  margin: auto;
  border-bottom: 1px solid #868686;
  margin-bottom: 5px;
}

.tag {
  padding: 5px 10px;
  background: #58acfa;
  color: #fff;
  font-size: 14px;
  margin-bottom: 5px!important;
  width: fit-content;
  margin-right: 5px;
}

.sry-msg {
  background: #a9d053;
  padding: 10px;
  margin: 20px;
  color: #ffffff;
}

@media screen and (min-width: 800px){
  .search-text {
    padding: 0;
    border: none;
    border-radius: 0;
    outline: none;
    background: none;
    font-size: 18px;
  }
  .kouzi {
    width: 1000px;
    padding: 20px;
    margin: auto;
    font-size: 18px;
  }
  .kouzi-img {
    width: 35%;
  }
  .requests-area, .items-area {
    margin-bottom: 10%;
  }

  .request-btn {
    position: fixed;
    top: 67vh;
    right: 0vw;
  }

  .requests-area {
    max-width: 1000px;
    margin: 0 auto;
  }
}

@media screen and (min-width: 1401px){
  .request-btn {
    position: fixed;
    top: 67vh;
    right: 5vw;
  }
}

@media screen and (min-width: 1551px){
  .request-btn {
    position: fixed;
    top: 67vh;
    right: 10vw;
  }
}

@media screen and (min-width: 1751px){
  .request-btn {
    position: fixed;
    top: 67vh;
    right: 15vw;
  }
}


</style>
